import {
  AFFIDAVIT_CONSENT_BEGIN,
  AFFIDAVIT_CONSENT_SUCCESS,
  AFFIDAVIT_CONSENT_FAILURE,
  GENERIC_ERROR_MESSAGE
} from "./types";
import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";

export const affidavitConsent = () => async (dispatch, getState) => {
  dispatch({ type: AFFIDAVIT_CONSENT_BEGIN });

  try {
    const response = await API({
      method: "POST",
      url: ENDPOINTS.SUBMIT_CONSENTED_DATE,
      data: {
        uniqueTxnId: getState().downloadAndDelete.uniqueTxnId
      }
    });

    if (response && response.data) {
      dispatch({ type: AFFIDAVIT_CONSENT_SUCCESS });
    } else {
      dispatch({ type: AFFIDAVIT_CONSENT_FAILURE, payload: GENERIC_ERROR_MESSAGE });
    }
  } catch (error) {
    dispatch({ type: AFFIDAVIT_CONSENT_FAILURE, payload: error.response.description });
  }
};
